import { render, staticRenderFns } from "./gaia-player2.vue?vue&type=template&id=25d5f565&scoped=true&"
import script from "./gaia-player2.vue?vue&type=script&lang=js&"
export * from "./gaia-player2.vue?vue&type=script&lang=js&"
import style0 from "./gaia-player2.vue?vue&type=style&index=0&id=25d5f565&lang=less&scoped=true&"
import style1 from "./gaia-player2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5f565",
  null
  
)

export default component.exports